<div class="page-count-pdf-container">
  <div class="page-count-header" *ngIf="canSelectPostPage">{{'pdf_export.module_page_count' | translate}}</div>
  <div class="page-count-selection" *ngIf="canSelectPostPage">
    <div class="d-flex flex-column page-item" *ngIf="maxPagePostEngagement">
      <span class="page-count-title">{{'pdf_export.post_engagement' | translate}}</span>
      <page-count-item [maximumItem]="maxPagePostEngagement" (pageChange)="onChangePostEngagementPage($event)"></page-count-item>
    </div>
    <div class="d-flex flex-column page-item" *ngIf="maxPageRoi">
      <span class="page-count-title">{{'pdf_export.roi_counter' | translate}}</span>
      <page-count-item [maximumItem]="maxPageRoi" (pageChange)="onChangeRoiPage($event)"></page-count-item>
    </div>
    <div class="d-flex flex-column page-item" *ngIf="maxPageInteraction">
      <span class="page-count-title">{{'pdf_export.interaction_counter' | translate}}</span>
      <page-count-item [maximumItem]="maxPageInteraction" (pageChange)="onChangeInteractionPage($event)"></page-count-item>
    </div>
  </div>
  <div>
    <button class="button download-btn blue"
            [ngClass]="{'mb-3': canExportCsv}"
            actionByLevels="Custom reports"
            [wallName]="'Reports Disabled'"
            (afterChecking)="exportPdf()">
      {{'common.btn.download_as_pdf' | translate}}
    </button>
  </div>
  <div>
    <button *ngIf="canExportCsv && !isSelectedPostCount"
            class="button download-btn blue"
            actionByLevels="Custom reports"
            [wallName]="'Reports Disabled'"
            (afterChecking)="exportCSV()"
            (afterChecking)="close()">
      {{'common.btn.download_as_csv' | translate}}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-pdf-export/measure-pdf-export.component.html